exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".store-icon{width:24px;height:24px}", ""]);

// exports
